export enum BRAND_NAMES {
  VAA = 'Virgin Atlantic',
}
